export default "__VITE_ASSET__BSr0jthr__"